import { render } from "./App.vue?vue&type=template&id=42705f3d&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=42705f3d&lang=css"

import exportComponent from "/home/runner/work/miki-ihara-law-and-patent-office/miki-ihara-law-and-patent-office/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__